import React, { useEffect, useState } from 'react';
import './WalletInfo.css';
import GameHeader from '../header/header';
import "../../Pages/Home/home.css"
import ApiService from '../../services/apiService';
import { Toast } from 'reactstrap';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { FaArrowLeft } from "react-icons/fa";

const WalletInfo = () => {
    const [crypto, setCrypto] = useState('USDC');
    const [network, setNetwork] = useState('ERC20');

    const [formData, setFormData] = useState({
        receiptAddress: '',
        phoneNumber: '',
        name: '',
    });
    const [loader, setLoader] = useState(false);
    const [userData, setItems] = useState();
    const apiService = new ApiService();
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            fetchuserData(items)
        }
    }, []);
    const fetchuserData = async (items) => {
        try {
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            setItems(res?.data[0]);
            const walletparam = new URLSearchParams();
            walletparam.append('userId', items?.nameid);
            const walletRes = await apiService.getApiParamater('GET_WALLET_DETAILS', `?${walletparam.toString()}`);
            debugger
            let walletdata = walletRes?.data[0]
            setFormData((prev) => ({
                ...prev,
                receiptAddress: walletdata?.receiptAddress,
                phoneNumber: walletdata?.phoneNumber,
                name: walletdata?.name,
            }));
            setCrypto(walletdata?.cryptocurrency)
            setNetwork(walletdata?.paymentNetwork)
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleLogin = async () => {
        setLoader(true)
        if (!formData?.receiptAddress) {
            toast.warning("Enter Wallet Address")
            setLoader(false)
            return;
        } else if (!formData?.phoneNumber) {
            toast?.warning("Enter Phone Number ")
            setLoader(false)
            return;
        } else if (!formData?.name) {
            toast?.warning("Enter name  ")
            setLoader(false)
            return;
        }
        const apiService = new ApiService();
        let body = {
            userId: userData?.id,
            name: formData?.name,
            receiptAddress: formData?.receiptAddress,
            cryptocurrency: crypto,
            paymentNetwork: network,
            phoneNumber: formData?.phoneNumber,
        }
        try {
            const response = await apiService.post('CREATE_WALLET', body);
            if (response?.status === 200) {
                toast.success("Wallet saved Sucessfully")
                setLoader(false)
            } else {
                toast.error(response?.data.message)
                setLoader(false)
            }

        } catch (error) {
            console.error("Error Save Wallet:", error);
            toast.error(error?.response?.data.message)
            setLoader(false)
        }
    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className='optimizeBox  mt-lg-5 p-lg-4'>
                <div className="wallet-header">
                    {/* <button className="back-button">←</button> */}
                    <h2>Wallet Info</h2>
                </div>

                <p className="wallet-warning">
                    Kindly be advised that it is imperative to refrain from divulging your personal information to any third party.
                    Our company will never request sensitive details from you. We strongly urge you to exercise caution and safeguard
                    your personal information to mitigate the risk of potential losses. Please note that our company will not assume
                    responsibility for any issues arising from the unauthorized sharing of personal information.
                </p>

                <div className="wallet-field">
                    <label>Full Name</label>
                    <input
                        type="text"
                        className="form-control p-2"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </div>

                <div className="wallet-field">
                    <label>Wallet Address</label>
                    <input
                        type="text"
                        className="form-control p-2"
                        id="receiptAddress"
                        name="receiptAddress"
                        value={formData.receiptAddress}
                        onChange={handleChange}
                    />
                </div>

                <div className="wallet-field">
                    <label>Phone Number</label>
                    <input
                        type="number"
                        className="form-control p-2"
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                    />
                </div>

                <div className="wallet-field">
                    <label>Cryptocurrency</label>
                    <div className="wallet-options">
                        {['USDT', 'USDC', 'ETH', 'BTC'].map((coin) => (
                            <label key={coin} className={`wallet-radio ${crypto === coin ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    name="crypto"
                                    checked={crypto === coin}
                                    onChange={() => setCrypto(coin)}
                                />
                                {coin}
                            </label>
                        ))}
                    </div>
                </div>

                <div className="wallet-field">
                    <label>Network</label>
                    <div className="wallet-options">
                        {['TRC20', 'ERC20', 'Bitcoin'].map((net) => (
                            <label key={net} className={`wallet-radio ${network === net ? 'selected' : ''}`}>
                                <input
                                    type="radio"
                                    name="network"
                                    checked={network === net}
                                    onChange={() => setNetwork(net)}
                                />
                                {net}
                            </label>
                        ))}
                    </div>
                </div>
                <div className='center p-3 '>
                    {loader === true ?
                        <button class="btn btn-scondary center w-100 btn-lg " type="button">
                            <ClipLoader color='#fff' />
                        </button>
                        :
                        <button class="btn btn-primary" onClick={handleLogin}>Submit</button>
                    }
                </div>
            </div>
        </div>
    );
};

export default WalletInfo;